import dynamic from 'next/dynamic'

export const SectionOfSteps = dynamic(() => import('./section-of-steps'))
